/* =============================================================================
 * A marca do Futigol.
 *
 * Mora aqui e nao em ui/componentes/ de proposito: componente so' entra la' se
 * NAO menciona dominio, e isto e' a coisa mais especifica que existe no app.
 *
 * O SVG e' inline, nao um arquivo em public/. Tres motivos, na ordem em que
 * pesam neste projeto:
 *   1. <img src> custa uma requisicao extra em 3G - a coisa em torno da qual
 *      esta base foi construida. Inline sao ~1,6 KB gzip dentro de um chunk que
 *      ja' esta' viajando, contra um round-trip de ~200 ms.
 *   2. Arquivo nao aceita recolorir por tema. Aqui o disco pega
 *      var(--cor-destaque) e a marca acompanha a identidade sozinha.
 *   3. futigol-branco.svg deixa de ser necessario: `color: #fff` no pai ja'
 *      produz a variante clara, porque o letreiro usa currentColor.
 *
 * Os `d` foram copiados verbatim de
 * c:\2DWeb\Prisma\FutigolOld\public\images\futigol.svg (viewBox 0 0 800 250).
 * O verde-oliva #65A844 do arquivo original nunca chega ao navegador.
 * ========================================================================== */

import { svg } from '@shared/ui/dom.js';

/** As seis letras de "Futigol". Sem classe no original: preto por omissao. */
const D_LETREIRO = [
    'M58.5,7.7c6.9,0,13.3,0.7,19.1,2.1c5.8,1.4,10.2,2.8,13.4,4.1l-7.2,29.5c-3.3-1.5-6.9-2.6-10.8-3.3c-3.9-0.7-7.5-1.1-10.8-1.1c-4.5,0-8.2,0.6-11.3,1.9c-3.1,1.2-5.5,2.9-7.2,5.1c-1.7,2.1-3,4.7-3.7,7.7c-0.7,3-1.1,6.2-1.1,9.7v6.4h45.6v30.7H38.9V200H2V62.7c0-16.9,4.7-30.2,14.3-40.1C25.7,12.7,39.8,7.7,58.5,7.7z',
    'M217.9,195.6c-6.3,1.8-14.4,3.5-24.3,5.1c-9.9,1.6-20.3,2.4-31.2,2.4c-11.1,0-20.3-1.5-27.6-4.5c-7.4-3-13.2-7.1-17.5-12.5c-4.3-5.4-7.4-11.8-9.2-19.2c-1.8-7.4-2.7-15.6-2.7-24.5V69.7h36.9v68.2c0,11.9,1.6,20.5,4.7,25.8c3.1,5.3,9,7.9,17.6,7.9c2.6,0,5.5-0.1,8.4-0.4c3-0.2,5.6-0.5,7.9-0.9V69.7h36.9V195.6z',
    'M251.3,37.2l36.9-5.9v38.4h44.4v30.7h-44.4v45.9c0,7.8,1.4,14,4.1,18.6c2.7,4.6,8.2,6.9,16.5,6.9c4,0,8.1-0.4,12.3-1.1c4.2-0.7,8.1-1.8,11.5-3.1l5.2,28.7c-4.5,1.8-9.4,3.4-14.9,4.7c-5.5,1.3-12.1,2-20.1,2c-10.1,0-18.4-1.4-25-4.1c-6.6-2.7-11.9-6.5-15.9-11.4c-4-4.9-6.7-10.8-8.3-17.7c-1.6-6.9-2.4-14.6-2.4-23V37.2z',
    'M403,32c0,6.8-2.2,12.1-6.6,16c-4.4,3.9-9.5,5.8-15.5,5.8s-11.1-1.9-15.5-5.8c-4.4-3.9-6.6-9.2-6.6-16c0-6.8,2.2-12.1,6.6-16c4.4-3.9,9.5-5.8,15.5-5.8s11.1,1.9,15.5,5.8C400.8,19.9,403,25.2,403,32z M399.5,200h-36.9V69.7h36.9V200z',
    'M546.7,183.7c0,21.3-5.4,37.1-16.2,47.5c-10.8,10.3-27.6,15.5-50.2,15.5c-7.9,0-15.9-0.7-23.8-2.1c-7.9-1.4-15.3-3.3-22.1-5.6l6.4-31c5.8,2.3,11.9,4.1,18.2,5.5c6.4,1.3,13.6,2,21.7,2c10.6,0,18.1-2.3,22.4-6.9c4.4-4.6,6.6-10.6,6.6-17.8v-4.7c-4,1.8-8.1,3.2-12.3,4.1c-4.2,0.9-8.8,1.4-13.8,1.4c-18,0-31.8-5.3-41.4-16c-9.6-10.7-14.4-25.6-14.4-44.7c0-9.6,1.5-18.3,4.5-26.1c3-7.8,7.3-14.6,13-20.2c5.7-5.6,12.7-10,20.9-13c8.3-3.1,17.6-4.6,28-4.6c4.5,0,9,0.2,13.8,0.6c4.7,0.4,9.4,1,14,1.6c4.6,0.7,9,1.4,13.3,2.4c4.2,0.9,8,1.9,11.3,2.9V183.7z M465.7,130.6c0,20.7,8.3,31,25,31c3.8,0,7.4-0.5,10.7-1.5c3.3-1,6.1-2.1,8.4-3.5v-59c-1.8-0.3-4-0.6-6.4-0.9c-2.5-0.2-5.4-0.4-8.7-0.4c-9.7,0-17,3.2-21.8,9.7C468.1,112.5,465.7,120.7,465.7,130.6z',
    'M793.9,202.5c-10.7-0.2-19.5-1.3-26.1-3.5c-6.7-2.1-12-5.2-15.9-9c-3.9-3.9-6.5-8.6-7.9-14.1c-1.4-5.5-2.1-11.8-2.1-18.7V13.7l36.9-5.9v142c0,3.3,0.2,6.3,0.7,8.9c0.5,2.6,1.4,4.9,2.9,6.7c1.4,1.8,3.4,3.3,6.1,4.5c2.6,1.2,6.2,1.9,10.7,2.2L793.9,202.5z',
];

/** O disco atras da bola. Era .st0 { fill:#65A844 } no original. */
const D_DISCO = 'M558.8,125.4c0-47,38.1-85,85-85c47,0,85,38.1,85,85s-38.1,85-85,85C596.9,210.5,558.8,172.4,558.8,125.4z';

/** A esfera. Era <circle class="st1" cx="643.2" cy="127.7" r="69.2">. */
const ESFERA = { cx: '643.2', cy: '127.7', r: '69.2' };

/** Contorno da bola mais os gomos, num path so'. Preto por omissao. */
const D_GOMOS =
    'M643.5,197.7c21.6,0,41-9.7,53.9-25c10.4-12.3,16.7-28.2,16.7-45.6c0-39-31.6-70.6-70.6-70.6c-24.4,0-46,12.4-58.6,31.3c-7.6,11.2-12,24.8-12,39.4C572.9,166.1,604.5,197.7,643.5,197.7z M707.1,133.3C707.2,133.4,707.2,133.4,707.1,133.3c-0.5,6.5-2.1,12.7-4.6,18.7c-0.8,1.9-1.7,3.8-2.7,5.6c0,0-0.1,0-0.1,0l-18.4,2.7l-7.2,1.1l-11.8-15.4l-0.3-0.4l7.7-23.7l18.6-6.1L707.1,133.3z M646.8,81.1l22.4-12.6c0,0,0.1,0,0.1-0.1c7.3,3.2,13.8,7.7,19.5,13.3c0.8,0.8,1.6,1.7,2.4,2.5c0,0,0,0.1,0,0.1l-4.9,25.2L667,116l-20.2-14.7L646.8,81.1L646.8,81.1z M657.4,150.6l11.6,15.1l-10,23.5c0,0,0,0.1,0,0.1c-5,1.2-10.2,1.9-15.4,1.9s-10.4-0.6-15.4-1.9c0,0,0-0.1,0-0.1l-10-23.5l11.6-15.1H657.4L657.4,150.6z M598.2,81.8c5.6-5.6,12.2-10.1,19.5-13.3c0,0,0.1,0,0.1,0.1l22.4,12.6v20.1l-19.1,13.9L620,116l-19.2-6.3l-2.3-11.6l-2.7-13.6c0,0,0-0.1,0-0.1C596.6,83.5,597.4,82.7,598.2,81.8z M587.2,157.7c-1-1.8-1.9-3.7-2.7-5.6c-2.5-6-4.1-12.2-4.7-18.6c0,0,0.1,0,0.1-0.1l19-17.5l18.6,6.1l7.7,23.7L613,161.5l-25.6-3.8C587.3,157.7,587.3,157.7,587.2,157.7z';

//A bola inteira ocupa esta janela dentro do viewBox original. Recortar por
//viewBox evita reescrever path - as coordenadas continuam as mesmas.
const JANELA_COMPLETA = { viewBox: '0 0 800 250', proporcao: 3.2 };
const JANELA_BOLA = { viewBox: '558 40 172 172', proporcao: 1 };

/**
 * A marca. O letreiro usa currentColor: quem define a cor e' o `color` do pai,
 * o que da' de graca a variante branca sobre o cabecalho escuro.
 *
 * @param {number}  altura    altura em px; a largura sai da proporcao
 * @param {boolean} comTexto  false devolve so' o simbolo (bola), quadrado
 * @param {string}  titulo    quando o pai ja' tem nome acessivel, passe null
 */
export function marcaFutigol({ altura = 28, comTexto = true, titulo = 'Futigol' } = {}) {
    const janela = comTexto ? JANELA_COMPLETA : JANELA_BOLA;

    const filhos = [
        titulo && svg('title', {}, titulo),
        comTexto &&
            svg(
                'g',
                { fill: 'currentColor' },
                D_LETREIRO.map((d) => svg('path', { d }))
            ),
        svg('path', { d: D_DISCO, fill: 'var(--cor-destaque)' }),
        svg('circle', { ...ESFERA, fill: 'var(--cor-bola)' }),
        svg('path', { d: D_GOMOS, fill: 'var(--cor-bola-marcas)' }),
    ];

    return svg(
        'svg',
        {
            class: 'marca',
            viewBox: janela.viewBox,
            width: String(Math.round(altura * janela.proporcao)),
            height: String(altura),
            //Sem nome proprio a marca vira ruido para o leitor de tela: quem
            //chama de dentro de um <a> que ja' se anuncia passa titulo: null.
            role: titulo ? 'img' : null,
            'aria-hidden': titulo ? null : 'true',
            focusable: 'false',
        },
        filhos
    );
}
